<div class="impressum">
  <mat-toolbar>
    <img
      [routerLink]="['']"
      routerLinkActive="router-link-active"
      width="150px"
      src="assets/images/integribox_logo_dark.png"
      alt="IntegriBox Logo"
    />
    <div class="flex w-100">
      <a
        class="text-dark link"
        tabindex="auto"
        (click)="goBack()"
        (keypress)="goBack()"
        [innerHTML]="'toolbar.back_to_website.content' | translate"
      ></a>
    </div>
  </mat-toolbar>
  <div>
    <mat-form-field
      class="lang-button small"
      appearance="fill"
      *mcRerender="trigger"
    >
      <mat-label
        [innerHTML]="'toolbar.language_selection_title.content' | translate"
      ></mat-label>
      <mat-select [(ngModel)]="lang" (selectionChange)="translate.use(lang)">
        @for (lang of translate.getLangs(); track lang) {
          <mat-option [value]="lang">
            {{ 'languages.' + lang | translate }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <div class="container p-5 text-dark">
    @for (part of collected_parts; track part) {
      <div [innerHTML]="part | translate"></div>
    }
  </div>
</div>
